import React from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { applyVueInReact } from 'vuereact-combined';
import PdfViewer from '@/components/WidgetForm/PdfViewer/PdfViewer.legacy.vue';
const VuePdfViewer = applyVueInReact(PdfViewer);

export default function Carousel({ documents }) {
	const renderThumbs = (children) =>
		children.map((child, index) => {
			const isPdf = child.props.children[0].props.pdfSrc;
			return (
				<div
					style={{
						maxHeight: '100px',
						width: isPdf ? '20px' : '100%',
						marginTop: isPdf ? '-57px' : '0px',
						transform: `scale(${isPdf ? 0.25 : 1})`,
					}}
					key={index}
				>
					{child.props.children[0]}
				</div>
			);
		});
	return (
		<ResponsiveCarousel infiniteLoop renderThumbs={renderThumbs}>
			{documents.map((document, index) => (
				<div key={index}>
					{document.src.includes('.pdf') ? <VuePdfViewer pdfSrc={document.src} /> : <img object-fit={'contain'} src={document.src} />}
					{document.title && <p className="legend">{document.title}</p>}
				</div>
			))}
		</ResponsiveCarousel>
	);
}
